export default {
    namespaced: true,
    state: {
        horario:{}
    },
    mutations: {
        SET_HORARIO(state, horario){
            state.horario = horario;
        },
        SET_EDITARHORARIO(state, nuevoHorario){
            var posicion = state.horario.map(function(h) { return h.dia; }).indexOf(nuevoHorario.dia);
            state.horario[posicion] = JSON.parse(JSON.stringify(nuevoHorario));
        },
    },
    actions: {
        setHorario({commit}, horario){
            commit('SET_HORARIO', horario);
        },
        setEditarHorario({commit}, nuevoHorario){
            commit('SET_EDITARHORARIO', nuevoHorario);
        },
    }
}